import { ScopeOption } from '../types';

const docsScope = (what: string, denyDesc: string): ScopeOption[] => [
  { value: 'all', label: 'Все документы', description: `${what}: по всей сети`, badgeColor: '#10b981' },
  { value: 'assigned_pharmacies', label: 'Курируемые аптеки', description: `${what}: только аптеки из myPharmacy`, badgeColor: '#3b82f6' },
  { value: 'own_region', label: 'Свой регион', description: `${what}: аптеки своего города (cityId)`, badgeColor: '#06b6d4' },
  { value: 'as_recipient', label: 'Я - получатель', description: `${what}: только где учетка оператора является получателем (привязка по guid)`, badgeColor: '#8b5cf6' },
  { value: 'my_documents', label: 'Мои документы', description: `${what}: только документы, созданные оператором, или где его учетка - получатель`, badgeColor: '#f59e0b' },
  { value: 'none', label: 'Запрещено', description: denyDesc, badgeColor: '#ef4444' }
];

const limitScope = (values: number[], def: number): ScopeOption[] => [
  ...values.map(v => ({
    value: String(v),
    label: `${v} строк`,
    description: `В запрос передается SELECT TOP ${v}`,
    badgeColor: '#3b82f6'
  })),
  { value: 'none', label: `По умолчанию (${def})`, description: `Настройка выключена - используется значение по умолчанию: ${def}`, badgeColor: '#6b7280' }
];

/**
 * Варианты скоупов для модуля «Главная» (home.*)
 */
export const homeScopes: Record<string, ScopeOption[]> = {
  'home.menu': [
    { value: 'true', label: 'Включено', description: 'Отображать «Главная» в боковом меню', badgeColor: '#10b981' },
    { value: 'none', label: 'Выключено', description: 'Пункт скрыт из бокового меню', badgeColor: '#ef4444' }
  ],

  'home.revenue.view': [
    { value: 'true', label: 'Разрешено', description: 'Виджет с выручкой аптеки за последние 7 дней (кабинет аптеки)', badgeColor: '#10b981' },
    { value: 'none', label: 'Запрещено', description: 'Виджет выручки скрыт', badgeColor: '#ef4444' }
  ],

  'home.notifications.view': [
    { value: 'true', label: 'Разрешено', description: 'Виджет с двумя последними уведомлениями', badgeColor: '#10b981' },
    { value: 'none', label: 'Запрещено', description: 'Виджет уведомлений скрыт', badgeColor: '#ef4444' }
  ],

  'home.documents.incoming.view': docsScope('Документы в статусе «В пути»', 'Виджет входящих документов скрыт'),
  'home.documents.incoming.limit': limitScope([5, 10, 25, 50, 100], 10),

  'home.documents.statuses.view': docsScope('Последние изменения статусов', 'Виджет статусов скрыт'),
  'home.documents.statuses.limit': limitScope([10, 25, 50, 100], 50),

  'home.documents.recent.view': docsScope('Последние документы (созданные и полученные)', 'Виджет последних документов скрыт'),
  'home.documents.recent.limit': limitScope([10, 25, 50, 100], 25),

  'home.documents.attention.view': docsScope('Документы, которые скоро будут автоматически отменены', 'Виджет документов, требующих внимания, скрыт'),
  'home.documents.attention.limit': limitScope([10, 25, 50, 100], 25),

  'home.report_today.view': [
    { value: 'true', label: 'Разрешено', description: 'Статус заполнения дневного отчёта своей аптеки (сегодня и вчера) - кабинет аптеки', badgeColor: '#10b981' },
    { value: 'none', label: 'Запрещено', description: 'Виджет «Отчёт за сегодня» скрыт', badgeColor: '#ef4444' }
  ],

  'home.documents.receiving.view': docsScope('Счётчики документов, ожидающих действия', 'Виджет «Ожидают действия» скрыт'),

  'home.documents.problem.view': docsScope('Документы в статусах «Отклонен», «Ошибка остатка», «Ошибка 1С»', 'Виджет проблемных документов скрыт'),
  'home.documents.problem.limit': limitScope([10, 25, 50, 100], 25),

  'home.journal.expiry.view': [
    { value: 'all', label: 'Вся сеть', description: 'Журнал сроков: все аптеки сети', badgeColor: '#10b981' },
    { value: 'assigned_pharmacies', label: 'Курируемые аптеки', description: 'Журнал сроков: только аптеки из myPharmacy', badgeColor: '#3b82f6' },
    { value: 'own_region', label: 'Свой регион', description: 'Журнал сроков: аптеки своего города (cityId)', badgeColor: '#06b6d4' },
    { value: 'own_pharmacy', label: 'Только своя аптека', description: 'Журнал сроков: только аптека самой учётной записи (привязка по guid)', badgeColor: '#8b5cf6' },
    { value: 'none', label: 'Запрещено', description: 'Виджет «Журнал сроков» скрыт', badgeColor: '#ef4444' }
  ],
  'home.journal.expiry.limit': limitScope([10, 25, 50, 100], 25),

  'home.reports.submission.view': [
    { value: 'all', label: 'Вся сеть', description: 'Сдача отчётов: все аптеки сети', badgeColor: '#10b981' },
    { value: 'assigned_pharmacies', label: 'Курируемые аптеки', description: 'Сдача отчётов: только аптеки из myPharmacy', badgeColor: '#3b82f6' },
    { value: 'own_region', label: 'Свой регион', description: 'Сдача отчётов: аптеки своего города (cityId)', badgeColor: '#06b6d4' },
    { value: 'none', label: 'Запрещено', description: 'Виджет «Сдача отчётов» скрыт', badgeColor: '#ef4444' }
  ],
  'home.reports.submission.limit': limitScope([10, 25, 50, 100], 25),

  'home.network_revenue.view': [
    { value: 'all', label: 'Вся сеть', description: 'Выручка: все аптеки сети', badgeColor: '#10b981' },
    { value: 'assigned_pharmacies', label: 'Курируемые аптеки', description: 'Выручка: только аптеки из myPharmacy', badgeColor: '#3b82f6' },
    { value: 'own_region', label: 'Свой регион', description: 'Выручка: аптеки своего города (cityId)', badgeColor: '#06b6d4' },
    { value: 'none', label: 'Запрещено', description: 'Виджет «Выручка сети» скрыт', badgeColor: '#ef4444' }
  ],

  'home.quick_links.view': [
    { value: 'true', label: 'Разрешено', description: 'Блок быстрых ссылок (каждая ссылка - только при наличии права на целевую страницу)', badgeColor: '#10b981' },
    { value: 'none', label: 'Запрещено', description: 'Блок быстрых ссылок скрыт', badgeColor: '#ef4444' }
  ],

  'home.promotions.view': [
    { value: 'true', label: 'Разрешено', description: 'Блок «Акции» на главной (пока заглушка)', badgeColor: '#10b981' },
    { value: 'none', label: 'Запрещено', description: 'Блок акций скрыт', badgeColor: '#ef4444' }
  ]
};
